module.exports = __webpack_public_path__ + "img/contact-sales-bg-left.71a21cb7.svg";